import React from "react";
import Paragraph from "../atoms/Paragraph";
import styled from "styled-components";
import { withModal } from "../../contexts/ModalContext";
import LanguageOption from "../atoms/LanguageOption";
import { Trans, useTranslation } from "react-i18next";
import { availableLanguages, getActiveLanguage } from "../../i18n";
const StyledParagraph = styled(Paragraph) `
  margin-bottom: 20px;

  span {
    font-weight: 700;
  }
`;
const Languages = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 25px;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    margin-left: -5px;
    margin-right: -5px;

    > * {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
`;
const LanguageModal = ({}) => {
    const { t } = useTranslation(["common"]);
    return (React.createElement("form", null,
        React.createElement(StyledParagraph, null,
            React.createElement(Trans, { i18nKey: "language.introduction", components: { emphasize: React.createElement("span", null) }, values: { language: getActiveLanguage().label } }),
            React.createElement("br", null),
            t("language.choose_other", { language: getActiveLanguage().label })),
        React.createElement(Languages, null, Object.keys(availableLanguages).map(key => (React.createElement(LanguageOption, { key: key, name: "language", image: availableLanguages[key].image, label: availableLanguages[key].label, value: key }))))));
};
export default withModal(LanguageModal);
